import { mul } from '@/common/js/api'
export default function getChartOpts(chartDimension, legends, xAxisData, yAxis, series) {
  return {
    legend: {
      height: 30,
      bottom: 0,
      itemWidth: 12,
      itemHeight: 6,
      align: 'right',
      data: legends,
      textStyle: {
        lineHeight: 4
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      padding: 10,
      confine: true,
      formatter: (params) => {
        let total = 0
        legends.forEach((ret, i) => {
          total += params[i]?.value || 0
        })
        const tooltips = legends.map((ret, i) => {
          let unit = ''
          let percent = 0
          if (total) {
            let val = (params[i]?.value || 0) / total
            if (val > 0 && val < 1) {
              const t = val.toString().split('.')
              if (t[1] && t[1].length > 4) val = parseFloat(val.toFixed(4))
            }
            percent = mul(val, 100)
          }
          if (chartDimension.includes('Rate')) unit = '%'
          else if (['paperUseAmount', 'amount', 'activeCost', 'createRoleCost', 'sumRecharge', 'sumMoney'].includes(chartDimension)) unit = '元'
          const percentShow = ['paperUseAmount', 'amount', 'downNum', 'newUserNum', 'createRoleNum', 'newRoleNum'].includes(chartDimension)
          const percentHtml = percentShow ? `<span>占比：${percent}%</span>` : ''
          if (params[i]) {
            return `<dd class="tooltop-span" style="font-size:12px;"><span style="background-color: ${params[i].color};"></span>${params[i].seriesName}: ${params[i].value} ${unit} ${percentHtml}</dd>`
          }
          return '<dd class="tooltop-span" style="font-size:12px;"></dd>'
        })
        let formatHtml = `<h3 class="tooltip-h3">${params[0].name}</h3>`
        formatHtml += tooltips.join('')
        return `<div style="width:280px;">${formatHtml}</div>`
      }
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: !0,
        position: 'bottom',
        offset: 0,
        data: xAxisData
      }
    ],
    yAxis,
    series,
    grid: { top: 35, left: 26, right: 16, bottom: 34, containLabel: !0 }
  }
}
